export default "__VITE_ASSET__DbcPhEbT__"